export const CONSTELADOR_SEO_PHRASE = 'Plataforma para Constelação Familiar';

export const CONSTELADOR_VIDEO_ID = '7p2qhXkqwo8';
export const CONSTELADOR_SHORT_VIDEO_URL = 'https://youtube.com/shorts/hrHMyNMTbec';
export const CONSTELADOR_WHATSAPP =
  'https://api.whatsapp.com/send/?phone=5513997701755&text=Ol%C3%A1%21%20Tenho%20d%C3%BAvidas%20sobre%20os%20planos%20para%20consteladores.';

/** Três mensagens centrais — visíveis logo no início da página */
export const consteladorValuePillars = [
  {
    title: 'Um novo jeito de fazer Constelação',
    text: 'Cenário virtual, avatares interativos e videochamada integrada, com a profundidade do presencial, sem improviso com bonecos na câmera.',
  },
  {
    title: 'Apresentação profissional',
    text: 'Transmita credibilidade desde o primeiro contato. Seus clientes percebem valor, se sentem acolhidos e recomendam seu trabalho.',
  },
  {
    title: 'Organização no atendimento',
    text: 'Tudo em um só lugar: sala, campo, vídeo e participantes. Menos fricção para você e mais clareza para quem está na sessão.',
  },
];

export const consteladorPurchaseSteps = [
  {
    step: '1',
    title: 'Escolha o plano',
    text: 'Selecione horas avulsas ou o plano associado, conforme o momento da sua carreira.',
  },
  {
    step: '2',
    title: 'Finalize a compra',
    text: 'Preencha os dados de pagamento e, se ainda não tiver conta, cadastre-se com e-mail e senha.',
  },
  {
    step: '3',
    title: 'Acesso imediato',
    text: 'Assim que o pagamento é confirmado, você já pode entrar na plataforma e acessar sua sala virtual.',
  },
  {
    step: '4',
    title: 'Tutorial por e-mail',
    text: 'Enviamos um guia completo por e-mail logo após a contratação, com o passo a passo para usar a plataforma.',
  },
  {
    step: '5',
    title: 'Comece a atender',
    text: "No painel, clique em 'Entrar na minha sala', convide seus clientes e conduza sua constelação com segurança.",
  },
];

export const consteladorFeatures = [
  {
    title: 'Avatares Interativos',
    text: 'O participante escolhido para fazer a representação escolhe um avatar e entra no cenário. Ele movimenta o avatar escolhido, possibilitando a visualização sistêmica e criando uma experiência próxima do presencial.',
  },
  {
    title: 'Videochamada Integrada',
    text: 'Tudo acontece dentro da própria plataforma, sem depender de aplicativos externos. Você envia o link da sua sala e os participantes te encontram na videochamada, diretamente na sua sala.',
  },
  {
    title: 'Tudo em um só lugar',
    text: 'Mais conforto para o terapeuta e para o cliente, com mais praticidade e menos improviso.',
  },
  {
    title: 'Cenário Virtual Profissional',
    text: 'O campo onde acontece a constelação. É possível visualizar o posicionamento e o olhar de cada participante, trazendo mais profundidade e percepção de valor.',
  },
];

export const consteladorBenefits = [
  {
    title: 'Atenda em todo o Brasil e no mundo',
    text: 'Amplie sua agenda aumentando sua área de atuação sem limites geográficos.',
    icon: '🌍',
  },
  {
    title: 'Encante seu cliente',
    text: 'Receba mais indicações com uma experiência diferenciada, encantadora e profissional.',
    icon: '✨',
  },
  {
    title: 'Ganhe mais autoridade',
    text: 'Diferencie seu trabalho com inovação e fortaleça seu posicionamento profissional.',
    icon: '🏆',
  },
  {
    title: 'Tudo integrado',
    text: 'Tenha tudo em uma única plataforma com mais conforto para você e seu cliente.',
    icon: '🔗',
  },
  {
    title: 'Ganhe visibilidade como profissional',
    text: 'Tenha visibilidade na vitrine de consteladores homologados e ganhe credibilidade.',
    icon: '⭐',
  },
];

export const consteladorHeroTestimonialScreens = [
  {
    id: 'josi-ferri-cura',
    src: '/assets/home/depoimentos/ig-josi-ferri-cura.png',
    alt: 'Stories de @josi.ferri sobre constelação em grupo online pelo Círculo C.U.R.A',
  },
  {
    id: 'josi-ferri-avatares',
    src: '/assets/home/depoimentos/ig-josi-ferri-avatares.png',
    alt: 'Stories de @josi.ferri sobre avatares e representação do campo na plataforma',
  },
  {
    id: 'jeniffer-stories',
    src: '/assets/home/depoimentos/ig-jeniffer-stories.png',
    alt: 'Stories de @jenifferplenus sobre constelação em grupo pela plataforma Constela Brasil',
  },
  {
    id: 'dres-santos',
    src: '/assets/home/depoimentos/ig-dres-santos.png',
    alt: 'Depoimento de @dresantosmentora sobre a ferramenta de constelação online',
  },
];

export const consteladorTestimonials = [
  {
    quote:
      'A plataforma me deu a confiança que eu precisava para atender com mais segurança e profissionalismo. Hoje transmito muito mais credibilidade, encanto meus clientes e não consigo imaginar fazer constelação online sem um cenário e o posicionamento do campo.',
    author: 'Consteladora',
  },
  {
    quote:
      'Eu tinha medo de atender online, mas a plataforma é bem simples e fácil de usar. Com os avatares e o cenário virtual, meus clientes ficam impressionados com a qualidade. Recebi mais indicações nos últimos 2 meses do que em todo o ano anterior.',
    author: 'Constelador',
  },
  {
    quote:
      'Que ideia genial! Parabéns mesmo!!! Dá para ver que tudo foi pensado para facilitar as constelações de um jeito muito prático e profissional. E poder atender em grupo dentro da plataforma eu achei simplesmente sensacional.',
    author: 'Consteladora',
  },
];

export const consteladorAudience = [
  { title: 'Recém-formados', text: 'Que ainda sentem insegurança para começar e querem iniciar com mais segurança e profissionalismo.' },
  { title: 'Terapeutas que já atendem', text: 'Que querem mais profissionalismo e desejam ampliar sua agenda além da sua cidade.' },
  { title: 'Professores', text: 'Profissionais que desejam oferecer uma experiência mais inovadora e se destacar no mercado.' },
  { title: 'Quem quer atender o Brasil', text: 'Consteladores que querem atender além da sua cidade e alcançar clientes em todo o país e no mundo.' },
];

export const consteladorFaqPurchase = [
  {
    q: 'O que é a Constela Brasil para consteladores?',
    a: 'É a Plataforma para Constelação Familiar desenvolvida exclusivamente para consteladores conduzirem sessões online, individual ou em grupo, com cenário virtual, avatares interativos e videochamada integrada em um único lugar.',
  },
  {
    q: 'Como faço a compra?',
    a: 'Escolha o plano abaixo, clique em contratar, preencha os dados de pagamento e conclua com seu e-mail e senha. O processo é simples e seguro.',
  },
  {
    q: 'Terei acesso imediato após a compra?',
    a: 'Sim. Assim que o pagamento é confirmado, você já pode fazer login na plataforma e acessar sua sala virtual, sem esperar dias ou etapas manuais.',
  },
  {
    q: 'Receberei algum tutorial?',
    a: 'Sim. Enviamos o tutorial completo por e-mail logo após a confirmação da compra, com o passo a passo para usar a plataforma. Também oferecemos suporte pelo WhatsApp.',
  },
  {
    q: 'E se eu precisar de ajuda durante a compra?',
    a: 'Basta clicar no botão do WhatsApp para falar conosco e receber suporte imediato.',
  },
  {
    q: 'Como acesso minha sala?',
    a: "Faça login na plataforma e clique em 'Entrar na minha sala' no painel.",
  },
  {
    q: 'O que faço após a compra ser confirmada?',
    a: 'Acesse sua conta imediatamente, confira o tutorial enviado por e-mail e entre na sua sala para começar a atender.',
  },
];

export const consteladorFaqGeneral = [
  {
    q: 'Preciso instalar algo?',
    a: 'Não! A plataforma funciona 100% no navegador. Basta acessar o link e a sessão começa. Funciona em computadores, tablets e celulares, sem downloads ou instalações complicadas.',
  },
  {
    q: 'Como funciona a cobrança?',
    a: 'Você pode comprar horas avulsas por R$ 19,90 cada, levar o pacote de 4 horas por R$ 69,90 ou assinar um plano mensal homologado a partir de R$ 139,90 (10 horas), com presença na vitrine de facilitadores. Também há planos de 15 horas (R$ 189,90) e 25 horas (R$ 225,90). A cobrança é feita de forma segura via nossa plataforma de pagamentos.',
  },
  {
    q: 'É fácil de usar?',
    a: 'Sim! A interface foi desenhada pensando em terapeutas de todas as idades. Em poucos cliques, você acessa a sala, convida o cliente e começa a movimentar os avatares. Oferecemos tutoriais em vídeo e suporte via WhatsApp.',
  },
  {
    q: 'E se eu não souber usar tecnologia ou tiver dúvidas? Tem suporte?',
    a: 'Sim, damos treinamento e suporte pelo WhatsApp.',
  },
  {
    q: 'Qual a diferença entre contratação por hora e associado?',
    a: 'Na contratação por hora, você utiliza a plataforma apenas quando precisar, sem mensalidade. No plano associado, além do uso da plataforma, você se torna homologado e visível na vitrine profissional, aumentando sua autoridade e suas chances de conquistar novos clientes.',
  },
];
